<div class="p-6 mx-auto max-w-[1800px] flex flex-col gap-6">
  <div class="toolbar pb-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
    <div class="toolbar-left">
      <div class="flex flex-col gap-1">
        <span class="text-xs font-semibold uppercase tracking-wider" style="color: var(--color-text-muted);">{{ 'tickets.operation' | translate }}</span>
        <h1 class="text-3xl font-semibold m-0" style="color: var(--color-text-primary); letter-spacing: -0.02em;">{{ 'tickets.title' | translate }}</h1>
      </div>
    </div>
  </div>

  <div class="flex items-center justify-between">
    <div class="flex items-center gap-3">
      <span class="text-sm font-semibold uppercase tracking-wider" style="color: var(--color-text-muted);">{{ 'tickets.title' | translate }}</span>
      <span class="text-xs font-medium px-2 py-0.5 rounded" style="color: var(--color-primary); background: var(--color-primary-light);">{{ pagination.total() }}</span>
    </div>
    <div class="flex items-center gap-3">
      <select
        class="text-sm px-3 py-1.5 rounded border border-(--color-border) bg-(--color-bg-primary) text-(--color-text-primary) focus:outline-none focus:border-(--color-primary)"
        (change)="onSortFieldChange($event)"
      >
        @for (field of sortFields; track field.value) {
          <option [value]="field.value" [attr.selected]="sortField() === field.value ? true : null">{{ field.label }}</option>
        }
      </select>
      <select
        class="text-sm px-3 py-1.5 rounded border border-(--color-border) bg-(--color-bg-primary) text-(--color-text-primary) focus:outline-none focus:border-(--color-primary)"
        (change)="onSortDirectionChange($event)"
      >
        @for (dir of sortDirections; track dir.value) {
          <option [value]="dir.value" [attr.selected]="sortDirection() === dir.value ? true : null">{{ dir.label }}</option>
        }
      </select>
      <app-view-toggle
        [value]="viewMode()"
        (valueChange)="viewMode.set($event)"
      />
    </div>
  </div>

  @if (viewMode() === 'table') {
    <app-table-general-simple
      [headers]="headers"
      [dataSource]="dataSource"
      [isLoading]="isLoading()"
      [menuButton]="menuButton"
      [buttonEvent]="false"
      [highlights]="estatusHighlights"
      (endElementEmitter)="onEndElement($event)"
    />

    <app-paginator
      [page]="pagination.page()"
      [total]="pagination.total()"
      [pageSize]="pagination.pageSize()"
      [setPage]="(page) => onPageChange(page)"
      [setPageSize]="(size) => onPageSizeChange(size)"
      [labelSingular]="'tickets.table.labelSingular' | translate"
      [labelPlural]="'tickets.table.labelPlural' | translate"
    />
  }

  @if (viewMode() === 'cards') {
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      @for (item of workflowProjects(); track item.id) {
        <app-card
          role="listitem"
          [title]="item.odt"
          [description]="item.curp || 'N/A'"
          [status]="item.status"
          [statusConfig]="statusConfig"
          [accentByStatus]="accentByStatus"
          [items]="getWorkflowProjectItems(item)"
          [actions]="getWorkflowProjectActions(item)"
        />
      }
    </div>

    <app-paginator
      [page]="pagination.page()"
      [total]="pagination.total()"
      [pageSize]="pagination.pageSize()"
      [setPage]="(page) => onPageChange(page)"
      [setPageSize]="(size) => onPageSizeChange(size)"
      [labelSingular]="'tickets.table.labelSingular' | translate"
      [labelPlural]="'tickets.table.labelPlural' | translate"
    />
  }
</div>
